import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FCFCFC",
  d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#6DA544",
  d: "M18.784 10.435h-1.565a5.217 5.217 0 0 1-10.435 0H5.219a6.785 6.785 0 0 0 4.93 6.526 1.74 1.74 0 0 0 .182 1.895l1.705-1.367 1.706 1.367c.45-.561.494-1.317.172-1.913a6.785 6.785 0 0 0 4.87-6.508"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FFDA44",
  d: "M7.828 9.913s0 2.609 2.609 2.609l.522.521h1.043s.522-1.565 1.565-1.565c0 0 0-1.043 1.044-1.043h1.565s-.522-2.087 2.087-3.653l-1.044-.521s-3.652 2.608-6.26 2.087V9.39H9.915l-.522-.522z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }